import Vue from "vue";
import App from "./App.vue";
import Home from "./views/Home";
import Login from "./views/Login";
import Detail from "./views/Detail";

import vuetify from "./plugins/vuetify";
import VueRouter from "vue-router";
import VueGlobalVar from "vue-global-var";
import moment from "moment";

import auth from "./middlewares/auth";
import notAuth from "./middlewares/not-auth";

// Global Variable
Vue.use(VueGlobalVar, {
    globals: {
        $api: "https://api-ppdb.smkruskudus.com/api/v2"
    }
});

Vue.filter("formatDate", value => {
    if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
    }
});

// Router
Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        };
    },
    routes: [{
            path: "/",
            name: "home",
            component: Home,
            meta: {
                middleware: auth
            }
        },
        {
            path: "/login",
            name: "login",
            component: Login,
            meta: {
                middleware: notAuth
            }
        },
        {
            path: "/siswa/:id",
            name: "detail",
            component: Detail,
            meta: {
                middleware: auth
            }
        }
    ]
});

function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    if (!subsequentMiddleware) return context.next;
    return (...parameters) => {
        context.next(...parameters);
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({
            ...context,
            next: nextMiddleware
        });
    };
}

router.beforeEach((to, from, next) => {
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ?
            to.meta.middleware : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to
        };

        const nextMiddleware = nextFactory(context, middleware, 1);
        return middleware[0]({
            ...context,
            next: nextMiddleware
        });
    }
    return next();
});

Vue.config.productionTip = false;

new Vue({
    vuetify,
    router,
    render: h => h(App)
}).$mount("#app");